import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

function RedefinirSenha() {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Extrai o token da URL
    const params = new URLSearchParams(location.search);
    const tokenValue = params.get('token');

    if (tokenValue) {
      setToken(tokenValue);
    } else {
      setMessage('Token inválido. Contate o suporte.');
    }
  }, [location]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    // Validações básicas
    if (!token || !newPassword || !confirmPassword) {
      setMessage('Preencha todos os campos.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('As senhas não coincidem.');
      return;
    }

    // if (newPassword.length < 6) {
    //   setMessage('A senha deve ter pelo menos 6 caracteres.');
    //   return;
    // }

    try {
      const response = await fetch(
        `https://rvensino.com.br/get.php?action=updateSenhaToken&token=${token}&senha=${newPassword}`,
        { method: 'GET' }
      );

      const textResponse = await response.text();

      let data;
      try {
        data = JSON.parse(textResponse);
      } catch (error) {
        console.error('Erro ao analisar JSON:', error);
        setMessage('Erro inesperado. Tente novamente.');
        return;
      }

      if (data.sucess) {
        setMessage(data.sucess + '');
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setMessage(data.error || 'Erro ao redefinir a senha.');
      }
    } catch (error) {
      console.error('Erro ao redefinir senha:', error);
      setMessage('Um erro ocorreu. Tente novamente mais tarde.');
    }
  };

  return (
    <div className="page-container login">
      <div className="login-container">
        <form onSubmit={handlePasswordReset} className="form-redefine-password">
          <div className="arrow-back cadastro">
            <Link to="/login" className="no-link-style">
              <ArrowBackOutlinedIcon style={{ color: '#000', fontSize: 35 }} className="sidebar-icon custom-arrow-icon" />
            </Link>
          </div>
          
          
          <Link to="/login" className="no-link-style">
            <img src="https://rvensino.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className="login-logo" />
          </Link>

          <input
            type="password"
            placeholder="Nova senha"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirmar nova senha"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button className="button" type="submit">
            Redefinir Senha
          </button>
          {message && <p className="message">{message}</p>}
        </form>
      </div>
    </div>
  );
}

export default RedefinirSenha;
